module.exports = __webpack_public_path__ + "bin/2cf8b12ba824361f448d32f72c305124.png";